export default "__VITE_ASSET__D2UvJUa7__"